import { Component, Injector, OnInit } from '@angular/core';
import { AVAILABLELANGUAGES_ES, defaultLanguage } from '@data/lang';
import { StorageKeys } from '@enums/storage.enum';
import { environment } from '@environments/environment';
import { LoaderManagmentService } from '@providers/loader-managment/loader-managment.service';
import { setAppInjector } from '@providers/service-locator/service.locator';
import { SessionDataProvider } from '@providers/session-data/session-data';
import { StorageService } from '@providers/storage/storage.service';
import { TranslationService } from '@providers/translation-new/translation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private injector: Injector,
    private loading: LoaderManagmentService,
    private sessionData: SessionDataProvider,
    private storage: StorageService,
    private translation: TranslationService
  ) {}

  async ngOnInit(): Promise<void> {
    setAppInjector(this.injector);
    const url = window.location.href;
    if (url?.includes('betades')) {
      environment.serverUrlAdmin = environment.serverUrlAdminBeta;
      environment.passerIdP.options.serverUrl = environment.passerIdP.options.serverUrlBeta;
      this.sessionData.isBetaServer = true;
    }
    await this.setLanguage();
  }

  async setLanguage(): Promise<void> {
    this.loading.dismissLoading();
    let userLang;
    try {
      const response = await this.storage.getMyData(StorageKeys.CURRENT_LANGUAGE);
      userLang = response ?? defaultLanguage;
    } catch (e) {
      userLang = defaultLanguage;
    }

    const lang = AVAILABLELANGUAGES_ES[userLang === defaultLanguage ? 1 : 0];
    this.translation.setCurrentLang(lang);
  }
}
